import { render, staticRenderFns } from "./CommonVacantLand.vue?vue&type=template&id=f6d14762&scoped=true&"
import script from "./CommonVacantLand.vue?vue&type=script&lang=ts&"
export * from "./CommonVacantLand.vue?vue&type=script&lang=ts&"
import style0 from "./CommonVacantLand.vue?vue&type=style&index=0&id=f6d14762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d14762",
  null
  
)

export default component.exports